/**
 * Listens for model vetting progress events from Electron and shows toasts.
 * Renders nothing — pure side-effect component.
 */

import { useEffect } from 'react';
import { useToast } from '../../contexts/ToastContext';
import type { VettingProgress } from '../../types/electron';

export function VettingToastListener() {
  const { addToast } = useToast();

  useEffect(() => {
    if (!window.isElectron || !window.electronLlm?.onVettingProgress) return;

    const unsubscribe = window.electronLlm.onVettingProgress((progress: VettingProgress) => {
      if (progress.phase === 'starting') {
        addToast(progress.message, 'info', { duration: 8000 });
      } else if (progress.phase === 'complete') {
        const type = progress.message.includes('0/') ? 'warning' : 'success';
        addToast(progress.message, type, { duration: 5000 });
      }
    });

    return unsubscribe;
  }, [addToast]);

  return null;
}
